import React, { FC } from 'react';
import { Container, Grid, Theme, Typography } from '@material-ui/core';
import { ImageSection } from 'components/energy5/structures';
import { makeStyles } from '@material-ui/styles';
import { startProjectImage } from 'assets/images/led-landing';
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      marginBottom: theme.spacing(6),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(14),
      },
    },
    underTitle: {
      [theme.breakpoints.up('sm')]: {
        fontSize: 36,
      },
    },
  };
});

const StartProjectSection: FC = () => {
  const { t } = useI18n();

  const classes = useStyles();

  return (
    <>
      <Container maxWidth={false} fixed>
        <Grid container justifyContent="center">
          <Grid item lg={8} md={10} xs={12}>
            <Typography variant="h1" className={classes.title} align="center" color="secondary">
              {t('landing.expert')}
            </Typography>
            <Typography
              variant="h2"
              className={classes.underTitle}
              align="center"
              color="secondary"
            >
              {t('landing.expert.start')}
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <ImageSection
        title={t('landing.expert.title')}
        text={t('landing.expert.description')}
        imageSrc={startProjectImage}
        width={1200}
        height={676}
        showBlueBgEffect
        imageBigLg
        setImageBorder
      />
    </>
  );
};

export default StartProjectSection;
